import React from 'react';
import { makeStyles } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import TDPTableSelectRedux from '../../TDP/TDPTableSelectRedux';
import TurmaDisciplinaProfessorProfileRedux from '../../TDP/TurmaDisciplinaProfessorProfileRedux';
import { useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import OAAlunoTable from './OAAlunoTable';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
        backgroundColor: '#f5f5f5',
    },
    table: {
        paddingTop: '20px;',
        margin: '20px'
    },
    title: {
        marginBottom: '20px'
    },
    cursorLink: {
        cursor: 'pointer'
    }, 
    tabMenu:{
        marginTop:'20px'
    }
});

export default function OAAlunoContainer() {
    const classes = useStyles();
    const tdp = useSelector(state => state.tdp);

    return (
        <div>
            <CssBaseline />
            <Container className={classes.paper} component={Paper}>
                <Grid container justify="space-between">
                    <Grid size={3}>
                        <Typography className={classes.title} variant="h5">
                            Observações
                        </Typography>
                    </Grid>
                </Grid>
                {tdp ?
                    <>
                        <TurmaDisciplinaProfessorProfileRedux />
                        <OAAlunoTable />
                        
                    </> :
                    <TDPTableSelectRedux />
                }
            </Container>
        </div>
    );
}